import { apiFetch } from '@app/lib/api'
import type {
  ChequeCalendarResponse,
  ChequeDirection,
  FreshnessResponse,
  TahsilatResponse,
} from '../../../worker/api/finans.types'

export type * from '../../../worker/api/finans.types'

export interface ChequeListParams {
  direction: ChequeDirection
  query: string
}

/** Defaults stay out of the URL — `issued` and an empty search send nothing. */
function chequeSearch(params: ChequeListParams): string {
  const search = new URLSearchParams()
  if (params.direction !== 'issued') search.set('direction', params.direction)
  if (params.query !== '') search.set('query', params.query)
  const query = search.toString()
  return query === '' ? '' : `?${query}`
}

export interface TahsilatParams {
  /** Absent = the API's default window (last 92 days by Istanbul today). */
  from?: string
  to?: string
  /** Namespaced token: `raw:<CKod>` or `alias:<advisorKod4>`. */
  customer?: string
  query: string
}

function tahsilatSearch(params: TahsilatParams): string {
  const search = new URLSearchParams()
  if (params.from) search.set('from', params.from)
  if (params.to) search.set('to', params.to)
  if (params.customer) search.set('customer', params.customer)
  if (params.query !== '') search.set('query', params.query)
  const query = search.toString()
  return query === '' ? '' : `?${query}`
}

export const finansApi = {
  cekler: (params: ChequeListParams) =>
    apiFetch<ChequeCalendarResponse>(`/finans/cekler${chequeSearch(params)}`),
  tahsilat: (params: TahsilatParams) =>
    apiFetch<TahsilatResponse>(`/finans/tahsilat${tahsilatSearch(params)}`),
  tazelik: () => apiFetch<FreshnessResponse>('/finans/tazelik'),
}

export const finansQueryKeys = {
  all: ['finans'] as const,
  cekler: (params: ChequeListParams) => ['finans', 'cekler', params] as const,
  tahsilat: (params: TahsilatParams) => ['finans', 'tahsilat', params] as const,
  tazelik: () => ['finans', 'tazelik'] as const,
}
